import { createStore } from 'redux'

const initialState = {

}

const reducerOps = (state = initialState, action) => {}

export default createStore(reducerOps, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())